import ForgotPasswordPageConfig from './auth/forgot-password/ForgotPasswordPageConfig';
import LockPageConfig from './auth/lock/LockPageConfig';
import Login2PageConfig from './auth/login-2/Login2PageConfig';
import MailConfirmPageConfig from './auth/mail-confirm/MailConfirmPageConfig';

import ContactInformationCollectionConfig from './contactInformationCollection/contactInformationCollectionConfig';
import TicketConfig from './ticket-conversation/ChatAppConfig';
import TicketOnging from './tickets-ongoing/AgentConfig';
import TicketHisConfig from './ticket-history/ChatHistoryConfig';
import ChatAppConfig from './chat/ChatAppConfig';
import ContactsAppConfig from './contacts/ContactsAppConfig';
import CannedAppConfig from './setting/canned/CannedAppConfig';
import TemplateAppConfig from './setting/TemplateMessages/TemplateAppConfig';
import AgentTemplateAppConfig from './setting/AgentsTemplateMessages/AgentTemplateAppConfig';
import PermissionConfig from './setting/permission/PermissionConfig';
import RolesConfig from './setting/roles/RolesConfig';
import UserConfig from './setting/users/UserConfig';
import AgentHandlingTimeConfig from './AgentHandlingTime/AgentHandlingTimeConfig.js';
import ServiceLevelConfig from './ServiceLevel/ServiceLevelConfig.js';
import ReportsAppConfig from './Reports/ReportsAppConfig';
import AdminDashboardAppConfig from './adminDashboard/AdminDashboardAppConfig';
import AgentConfig from './agent-conversation/AgentConfig';
import ContactGroupConfig from './ContactGoup/ContactGroupConfig';
import TokenConfig from './auth/token/TokenConfig';
import ResetPassword2PageConfig from './auth/reset-password-2/ResetPassword2PageConfig';
import BlockAppConfig from './BlockedContacts/BlockAppConfig';
import ProfileAppConfig from './profile/ProfileAppConfig';
import ChatHistoryConfig from './chat-history/ChatHistoryConfig';
import CompanyProfileConfig from './company-profile/CompanyProfileConfig';
import Error404LoggedOutPageConfig from './errors/404-logged-out/Error404LoggedOutPageConfig';
import OptConfig from './opt/OptConfig';
import OptReportAppConfig from './optReport/OptReportAppConfig';
import SurveyCOnfig from './Reports/surveyReport/SurveyConfig';
import SessionTime from './setting/sessionTime/SessionConfig';
import MessagesConfig from './messages/MessagesConfig';
import AgentMessagesConfig from './templateReports/MessagesConfig';
import FacebookConfig from './fb-catalouge/config';
import AutoReplyConfig from './autoReply/config';
import FlagConfig from './setting/flagSuperAdmin/FlagConfig';
import ComplainTicketConfig from './complainTickets/ComplainTicketConfig';
import InternetConfig from './errors/InternetConnectivity/internetConfig';
import ComplainTicketsReport from './Reports/tickets/ComplainTicketsReport';
import ChannelsConfig from './allChannels/ChannelsConfig';
import PrivacyPolicyConfig from './privacy-policy/PrivacyPolicyConfig';
import SessionsMau from './setting/sessionsMau/Config';
// import NearestLocationConfig from './setting/nearestLocations/NearestLocationConfig';
import BTWhatsappConfig from './auth/back-to-whatsapp/BTWhatsappConfig';
import LocationUpdateConfig from './locationUpdate/LocationUpdateConfig';
import ReminderMessagesConfig from './setting/reminderMessages/reminderMsgsConfig';
import segmentsConfig from './setting/segments/segmentsConfig';
import SMSConfig from './sms/SMSConfig';
import CheckNumberConfig from './setting/checkNumber/Config';
import BlacklistTokenConfig from './setting/blacklistToken/Config';
import AgentAvgTimeConfig from './agentAvgTime/AgentAvgTimeConfig';
import BillingConfig from './setting/billing/Config';
import ClearNumberConfig from './setting/clearNumberCache/Config';
import CurrCampaignsConfig from './setting/currentCampaigns/Config';
import OTPConfig from './setting/otp/Config';
import IPWhitelistConfig from './setting/ipWhitelist/Config';
import TicketsReportConfig from './TicketsReport/TicketsReportConfig';
import WebhookConfig from './setting/clientWebhook/Config';
import labelsConfig from './setting/labels/labelsConfig';
import AccountConfig from './setting/accountLimits/AccountConfig';
import OtpLogsConfig from './OtpLogs/OtpLogsConfig';
import CallHistoryConfig from './Reports/CallHistory/CallHistoryConfig';
import PBXCallsConfig from './PBXCalls.js/PBXCallsConfig';
import TemplateSummaryConfig from './templateSummary/TemplateSummaryConfig';
import TemplateAnalyticsAdminConfig from './Reports/TemplateAnalyticsAdmin/TemplateAnalyticsAdminConfig';
import ChatbotAnalyticsConfig from './ChatbotAnalytics/ChatbotAnalyticsConfig';
import EmailCampaignConfig from './EmailCampaign/EmailCampaignConfig';
import CountryBasedChatbotConfig from './setting/countryBasedChatbot/Config';
import VoicePortalConfig from './VoicePortal/VoicePortalConfig';
import SystemPermissionsConfig from './setting/systemPermissions/SystemPermissionsConfig';
import SaChannelsConfig from './SaChannels/SaChannelsConfig';
import SwichPaymentConfigurationConfig from './setting/swichPaymentConfiguration/SwichPaymentConfigurationConfig';
import NumberConfig from './setting/number/NumberConfig';
import CallCenterReportConfig from './callCenterReport/CallCenterReportConfig';
import CallCenterAgentLogsConfig from './callCenterAgentLogs/CallCenterAgentLogsConfig';
import CallCenterUsersConfig from './CallCenterUsersSuperAdmin/CallCenterUsersConfig';
import CallCenterTicketsConfig from './callCenterTickets/CallCenterTicketsConfig';
import AICallConfig from './AICall/AICallConfig';
import CallChatbotConfig from './callChatbot/CallChatbotConfig';
import CampaignManagementConfig from './TemplateMessagesNew/CampaignManagement/CampaignManagementConfig';
import ApiOutboxConfig from './TemplateMessagesNew/ApiOutbox/ApiOutboxConfig';
import EmailInboxConfig from './emailInbox/EmailInboxConfig';
import AICallProvidersConfig from './setting/aiCallProviders/Config';
import DynamicBannerConfig from './dynamicBanner/DynamicBannerConfig';
import OrdifyConfig from './ordify/OrdifyConfig';
import CampaignApprovalsConfig from './campaignApprovals/CampaignApprovalsConfig';
import WhatsAppMobileConfig from './whatsapp-mobile/WhatsAppMobileConfig';

const allPagesConfig = [
	CompanyProfileConfig,
	ContactGroupConfig,
	ChatHistoryConfig,
	ProfileAppConfig,
	BlockAppConfig,
	ForgotPasswordPageConfig,
	MailConfirmPageConfig,
	LockPageConfig,
	Login2PageConfig,
	ResetPassword2PageConfig,
	ContactInformationCollectionConfig,
	ChatAppConfig,
	ReportsAppConfig,
	ContactsAppConfig,
	CannedAppConfig,
	PermissionConfig,
	RolesConfig,
	UserConfig,
	AgentHandlingTimeConfig,
	ServiceLevelConfig,
	TemplateAppConfig,
	AgentTemplateAppConfig,
	AdminDashboardAppConfig,
	AgentConfig,
	TokenConfig,
	Error404LoggedOutPageConfig,
	OptConfig,
	OptReportAppConfig,
	SurveyCOnfig,
	SessionTime,
	MessagesConfig,
	AgentMessagesConfig,
	FlagConfig,
	FacebookConfig,
	AutoReplyConfig,
	TicketConfig,
	ComplainTicketConfig,
	InternetConfig,
	TicketHisConfig,
	TicketOnging,
	ComplainTicketsReport,
	ChannelsConfig,
	PrivacyPolicyConfig,
	SessionsMau,
	// NearestLocationConfig,
	BTWhatsappConfig,
	LocationUpdateConfig,
	ReminderMessagesConfig,
	segmentsConfig,
	SMSConfig,
	CheckNumberConfig,
	BlacklistTokenConfig,
	AgentAvgTimeConfig,
	BillingConfig,
	ClearNumberConfig,
	CurrCampaignsConfig,
	OTPConfig,
	IPWhitelistConfig,
	TicketsReportConfig,
	WebhookConfig,
	labelsConfig,
	//Here the Log Config Route For OTPLog file
	OtpLogsConfig,
	CallHistoryConfig,
	//account Config
	AccountConfig,
	PBXCallsConfig,
	TemplateSummaryConfig,
	TemplateAnalyticsAdminConfig,
	ChatbotAnalyticsConfig,
	EmailCampaignConfig,
	CountryBasedChatbotConfig,
	VoicePortalConfig,
	SystemPermissionsConfig,
	SaChannelsConfig,
	SwichPaymentConfigurationConfig,
	NumberConfig,
	CallCenterReportConfig,
	CallCenterAgentLogsConfig,
	CallCenterUsersConfig,
	CallCenterTicketsConfig,
	AICallConfig,
	CallChatbotConfig,
	CampaignManagementConfig,
	ApiOutboxConfig,
	EmailInboxConfig,
	OrdifyConfig,
	AICallProvidersConfig,
	DynamicBannerConfig,
	CampaignApprovalsConfig,
	WhatsAppMobileConfig
];

export default allPagesConfig;
